<template>
  <div class="ac-card-content">
    <div class="ac-header-container flex-column">
      <div class="flex-row just-between" style="width: 100%">
        <div class="ac-header">
          {{ contact.id ? 'Edit' : 'Add New' }} Contact
        </div>
        <button class="ac-close-button" @click="toggle(false)">
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          />
        </button>
      </div>
    </div>
    <div class="ac-body-container">
      <div
        v-if="
          (contact.isPrimary
            || contacts.find(
              (x) => x.isPrimary && x.contactType === contact.contactType,
            ) === undefined)
            && contact.contactType === 'Business'
        "
        class="sac__font-16 bold flex align-center mb-3"
      >
        Primary Contact
        <v-icon medium color="black" class="ml-1 mb-1">
          mdi-star-outline
        </v-icon>
      </div>
      <div class="flex-row">
        <div class="ac-input-container mr-2">
          <div class="ac-input-header">
            First Name
            {{ contact.contactType === 'ServiceReq' ? '(optional)' : '' }}
          </div>
          <SACInput
            field="firstName"
            placeholder="Enter First Name"
            :value="firstName"
            :error="errorObj.firstNameErr"
            :change="onChange"
          />
        </div>
        <div class="ac-input-container ml-2">
          <div class="ac-input-header">
            Last Name
            {{ contact.contactType === 'ServiceReq' ? '(optional)' : '' }}
          </div>
          <SACInput
            field="lastName"
            placeholder="Enter Last Name"
            :value="lastName"
            :error="errorObj.lastNameErr"
            :change="onChange"
          />
        </div>
      </div>
      <div class="flex-row">
        <div class="ac-input-container mr-2">
          <div class="ac-input-header">
            Email
          </div>
          <SACInput
            field="email"
            placeholder="Enter Email"
            :value="email"
            :error="errorObj.emailErr"
            :change="onChange"
          />
        </div>
        <div class="ac-input-container ml-2">
          <div class="ac-input-header">
            Phone
          </div>
          <SACInput
            field="phone"
            placeholder="Enter Phone"
            :value="phone"
            :error="errorObj.phoneErr"
            :change="onChange"
          />
        </div>
      </div>
      <div class="flex-row">
        <div class="ac-input-container mr-2">
          <div class="ac-input-header mr-2">
            Department or Role
          </div>
          <SACInput
            field="title"
            placeholder="Enter Department or Role"
            :value="title"
            :error="errorObj.titleErr"
            :change="onChange"
          />
        </div>
        <div
          v-if="contact.contactType === 'ServiceReq'"
          class="ac-input-container ml-2"
        >
          <div class="ac-input-header">
            Support URL
          </div>
          <SACInput
            field="websiteLink"
            prefix="https://"
            placeholder="Enter Support URL"
            :value="websiteLink"
            :error="errorObj.websiteLink"
            :change="onChange"
          />
        </div>
      </div>
      <div
        v-if="
          contact.contactType === 'Business'
            && !contact.isPrimary
            && contacts.find(
              (x) => x.isPrimary && x.contactType === contact.contactType,
            )
        "
        class="mt-4"
      >
        <SACCheckbox
          label="Make Primary Contact"
          :checked="isPrimary"
          :change="togglePrimary"
        />
        <div v-if="isPrimary" class="sac__font-14 tomato mt-2">
          Saving will remove Primary Contact status from
          {{
            contacts.find(
              (x) => x.isPrimary && x.contactType === contact.contactType,
            ).firstName
          }}
        </div>
      </div>
      <div v-if="contact.contactType === 'ServiceReq'">
        <RecipientSetting
          label="Also send a copy of notifications to"
          :recipients="emails"
          :email="emailCopy"
          :addEmail="addEmail"
          :removeEmail="removeEmail"
          :onChange="handleChange"
          :errorObj="{}"
        />
      </div>
    </div>
    <div class="ac-footer-container just-between">
      <button
        v-if="contact.id && !contact.isPrimary"
        class="del-btn"
        @click="toggle(true, 'delete-contact', contact)"
      >
        Delete
      </button>
      <div v-else />
      <div>
        <button type="button" class="icn-btn" @click="toggle(false)">
          Cancel
        </button>
        <button type="button" class="fill-btn" @click="updatePartnerConfig">
          Save
        </button>
      </div>
    </div>
    <ProcessOverlay :show="updating" text="Saving" />
  </div>
</template>

<script>
import SACInput from '@shared/components/sac/SACInput.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';
import formatPhoneNumber from '@shared/lib/formatter/formatPhoneNumber';
import RecipientSetting from '../shared/RecipientSetting.vue';

export default {
  name: 'EditContactPopup',
  components: {
    SACInput,
    SACCheckbox,
    ProcessOverlay,
    RecipientSetting,
  },
  mixins: [partnerSettingsMixin],
  props: {
    toggle: Function,
    states: Array,
    contact: Object,
    update: Function,
    currentCorporation: Object,
  },
  data() {
    const {
      firstName = '',
      lastName = '',
      email = '',
      phone = '',
      title = '',
      websiteLink = '',
      emailCopy = '',
      category = '',
      isPrimary = false,
    } = this.contact;
    return {
      firstName,
      lastName,
      email,
      phone,
      title,
      isPrimary,
      category,
      websiteLink: websiteLink?.replace('https://', ''),
      emails: emailCopy ? JSON.parse(emailCopy) : [],
      emailCopy: '',
      errorObj: {},
      updating: false,
    };
  },
  watch: {
    contact(nAddress) {
      const {
        firstName = '',
        lastName = '',
        email = '',
        phone = '',
        title = '',
        category = '',
        isPrimary = false,
      } = nAddress;
      this.firstName = firstName;
      this.lastName = lastName;
      this.title = title;
      this.isPrimary = isPrimary;
      this.category = category;
      this.email = email;
      this.phone = phone;
      this.errorObj = {};
    },
  },
  methods: {
    onChange(field, value) {
      let v = value;
      if (field === 'phone') {
        v = formatPhoneNumber(v);
      }
      this[field] = v;
    },
    handleChange(field, value) {
      this.emailCopy = value;
    },
    addEmail() {
      this.emails.push(this.emailCopy);
      this.emailCopy = '';
    },
    removeEmail(ix) {
      this.emails.splice(ix, 1);
    },
    togglePrimary() {
      this.isPrimary = !this.isPrimary;
    },
    async updatePartnerConfig() {
      const {
        firstName,
        lastName,
        email,
        phone,
        title,
        category,
        websiteLink,
        emails,
        isPrimary,
      } = this;
      const errorObj = {};
      if (this.contact.contactType !== 'ServiceReq') {
        if (!firstName) {
          errorObj.firstNameErr = 'First name is required.';
        }
        if (!lastName) {
          errorObj.lastNameErr = 'Last name is required.';
        }
      }
      if (!email) {
        errorObj.emailErr = 'Email is required.';
      }
      if (!phone) {
        errorObj.phoneErr = 'Phone is required.';
      }
      this.errorObj = errorObj;
      if (Object.keys(errorObj).length === 0) {
        this.updating = true;
        if (this.contact.id) {
          await this.$store.dispatch('editPartnerContact', {
            ...this.contact,
            firstName,
            lastName,
            title,
            phone,
            email,
            isPrimary,
            websiteLink: `https://${websiteLink}`,
            emailCopy: JSON.stringify(emails),
            serviceCategory: category,
          });
          if (this.contact.isPrimary !== isPrimary && isPrimary) {
            const oldPrimary = this.contacts.find(
              (x) => x.isPrimary && x.contactType === this.contact.contactType,
            );
            if (oldPrimary && oldPrimary.id !== this.contact.id) {
              await this.$store.dispatch('editPartnerContact', {
                ...oldPrimary,
                isPrimary: false,
              });
            }
          }
        } else if (
          this.contacts.find(
            (x) => x.isPrimary && x.contactType === this.contact.contactType,
          )
          || this.contact.contactType !== 'Business'
        ) {
          await this.$store.dispatch('createPartnerContact', {
            ...this.contact,
            corpId: this.currentCorporation.id,
            firstName,
            phoneCo: '+1',
            lastName,
            title,
            phone,
            email,
            websiteLink,
            emailCopy: JSON.stringify(emails),
            isPrimary,
          });
          if (isPrimary && this.contact.contactType === 'Business') {
            const oldPrimary = this.contacts.find(
              (x) => x.isPrimary && x.contactType === this.contact.contactType,
            );
            if (oldPrimary !== this.contact.id) {
              await this.$store.dispatch('editPartnerContact', {
                ...oldPrimary,
                isPrimary: false,
              });
            }
          }
        } else {
          await this.$store.dispatch('createPartnerContact', {
            ...this.contact,
            corpId: this.currentCorporation.id,
            firstName,
            phoneCo: '+1',
            lastName,
            title,
            phone,
            email,
            isPrimary: true,
          });
        }

        this.$store.dispatch('showSuccessToast', {
          message: 'Contact updates has been saved.',
        });
        this.updating = false;
        this.toggle(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sac-checkbox {
  border: 2px solid $N40;

  &.active {
    border: 0px white;
  }
}

.mdi-checkbox-blank-outline::before,
.mdi-checkbox-marked::before,
.mdi-minus-box::before,
.mdi-arrow-up::before {
  color: $WHITE;
}

.mdi-checkbox-marked::before {
  color: $NBLUE100;
}
</style>
